import { render, staticRenderFns } from "./FishingPermitTable.vue?vue&type=template&id=07501262&scoped=true&lang=true&"
import script from "./FishingPermitTable.vue?vue&type=script&lang=js&"
export * from "./FishingPermitTable.vue?vue&type=script&lang=js&"
import style0 from "./FishingPermitTable.vue?vue&type=style&index=0&id=07501262&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07501262",
  null
  
)

export default component.exports